/**
 * @generated SignedSource<<db53c06f4c6fd7e5ea190fc8679fa10d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteProjectInput = {
  id: string;
  deleteAllProjects?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deleteProjectMutation$variables = {
  input: DeleteProjectInput;
};
export type deleteProjectMutation$data = {
  readonly deleteProject: {
    readonly deletedProjectId: string | null;
    readonly errors: ReadonlyArray<string | null> | null;
  } | null;
};
export type deleteProjectMutation = {
  variables: deleteProjectMutation$variables;
  response: deleteProjectMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteProjectPayload",
    "kind": "LinkedField",
    "name": "deleteProject",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedProjectId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteProjectMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteProjectMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a393b9f48d8d3a5341ca769facc3941c",
    "id": null,
    "metadata": {},
    "name": "deleteProjectMutation",
    "operationKind": "mutation",
    "text": "mutation deleteProjectMutation(\n  $input: DeleteProjectInput!\n) {\n  deleteProject(input: $input) {\n    deletedProjectId\n    errors\n  }\n}\n"
  }
};
})();

(node as any).hash = "d7ebc8a160bdf195b10a51faba528e4a";

export default node;
